module.exports = __webpack_public_path__ + "static/media/bms_logo_rgb_pos_150.5f9e2a9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bms_logo_rgb_pos_150.png
// module id = 1361
// module chunks = 0